<template>
  <div>
    <div class="l-404">
      <h1>404 NotFound</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data: function() {
    return {
      title: 'お探しのページは見つかりませんでした',
      description: ''
    };
  },
  mounted() {
    this.setMeta(this.title, this.description);
  }
};
</script>

<style lang="scss" scoped>
.l-404 {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
h1 {
  color: $white;

  @include mq-up() {
    @include fz(40);
  }

  @include mq-down() {
    @include fz(24);
  }
}
</style>
